import React,{useRef} from "react";
import classes from "../Stage.module.css";

const Seat = (props) =>{
    const container = useRef(null)

    const activate = (event)=>{
        props.onClick(props.value)
        const active = document.getElementsByClassName(classes.active)[0]
        if(active != undefined || active != null){
            active.classList.remove(classes.active)
        }
        container.current.classList.add(classes.active)
    }

    return <div className={props.className} ref={container} onClick={activate}>
        {props.children}
    </div>
}
export default Seat